import React from 'react';
import clsx from 'classnames';
import './index.css';
import { Position } from 'components';
import Increment from './components/Increment';
import Content from './components/Content';
import QueueAnim from 'rc-queue-anim';
import { usePageTitle } from '../../hooks';

const ServiceContent = () => {
  // 设置页面标题
  usePageTitle('服务内容');
  const bannerList = [
    {
      img: '/img/serviceBig.jpg',
      className: 'servicecontent-top-banner-big',
    },
    {
      img: '/img/serviceSmall.jpg',
      className: 'servicecontent-top-banner-small',
    },
  ];

  return (
    <div
      className={clsx('servicecontent-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部banner */}
      {bannerList.map((item, index) => (
        <img
          key={index}
          src={item.img}
          alt=''
          width={'100%'}
          height={'100%'}
          className={clsx(item.className)}
        />
      ))}
      {/* 当前位置 */}
      <Position list={['首页', '服务内容']} />
      <QueueAnim type={['bottom', 'top']}>
        {/* 服务内容 */}
        <div key='content'>
          <Content />
        </div>
        {/* 增值服务 */}
        <div key='increment'>
          <Increment />
        </div>
      </QueueAnim>
    </div>
  );
};

export default ServiceContent;
